import { TableCell, Typography, styled } from "@mui/material"
import theme from "@skistarab/mui-theme"

export const PrimaryText = styled(Typography)({
  fontWeight: "bold",
  fontSize: "0.875rem",
})

export const SecondaryText = styled(Typography)({
  fontSize: "0.75rem",
})

const CenteredCell = styled(TableCell)(({ theme }) => ({
  textAlign: "center",
  padding: "8px",
  borderRight: `1px solid ${theme.palette.divider}`,
  "&:first-of-type, &:last-of-type": {
    borderRight: "none",
  },
}))

export const HeaderCell = styled(CenteredCell)({
  border: "none",
})

export const UnitCell = styled(CenteredCell)({
  backgroundColor: "#F3F3F3",
  border: "none",
})

export const TitleCell = styled(CenteredCell)({
  fontSize: "1.125rem",
  fontWeight: "bold",
  fontFamily: theme.typography.h1.fontFamily,
  backgroundColor: "#F3F3F3",
})

export const ContentCell = styled(CenteredCell)({})
